import * as React from 'react';
import { ReactNode } from 'react';
import './Tabs.scss';
import TabTitle from './../TabTitle';

interface ITabTitleData {
  title: string;
  count: number;
  showCount: boolean;
}

interface ITabsProps {
  tabTitles: ITabTitleData[];
  tabContents: ReactNode[];
  currentTab: number;
  selectTab: (index: number) => void;
}

export class Tabs extends React.Component<ITabsProps, {}> {
  private renderTab = (tabTitle: ITabTitleData, index: number) => {
    const classes =
      'rp-tabs--tab' + (this.props.currentTab === index ? ' selected' : '');
    return (
      <span
        key={index}
        className={classes}
        onClick={() => this.props.selectTab(index)}
      >
        <TabTitle
          title={tabTitle.title}
          count={tabTitle.count}
          showCount={tabTitle.showCount}
          disabled={index !== this.props.currentTab}
        />
      </span>
    );
  };

  private renderTabs = () => {
    return this.props.tabTitles.map((title, index) =>
      this.renderTab(title, index)
    );
  };

  private renderContent = () => {
    return this.props.tabContents[this.props.currentTab];
  };

  public render() {
    return (
      <div className="rp-tabs">
        <div className="rp-tabs--tabs no-select">{this.renderTabs()}</div>
        <div className="rp-tabs--content">{this.renderContent()}</div>
      </div>
    );
  }
}
